const manageMail = {
  manageMail: {
    pageTitle: '메일 관리',
    description: '이메일 수신자 등록, 수정, 삭제 및 발송 상태를 관리할 수 있습니다.',
    tabs: {
      schedule: '스케줄 수신자',
      payment: '결제 수신자',
      inquiry: '문의 수신자'
    },
    searchPlaceholder: '검색',
    buttons: {
      delete: '삭제',
      add: '추가',
      cancel: '취소'
    },
    deleteModal: {
      title: '수신자 삭제',
      body: '선택한 수신자를 정말 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.'
    },
    categories: {
      guideTitle: '메일 카테고리 가이드',
      schedule: '예약·스케줄 관련 알림 메일을 모두 수신합니다.',
      payment: '결제·청구·거래와 관련된 메일을 수신합니다.',
      inquiry: '문의·고객지원 등 연락 관련 메일을 수신합니다.',
      passResult: '교신(통신)이 끝난 뒤 발송되는 결과 메일을 수신합니다.'
    },
    addModal: {
      categorySelectHint: '왼쪽에서 카테고리를 선택하면 설명이 표시됩니다.'
    }
  }
};

export default manageMail;